"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = exports.NoteType = exports.HistoryType = exports.ImportConnectorType = void 0;
var ImportConnectorType;
(function (ImportConnectorType) {
    ImportConnectorType["aeries"] = "aeries";
})(ImportConnectorType = exports.ImportConnectorType || (exports.ImportConnectorType = {}));
var HistoryType;
(function (HistoryType) {
    HistoryType["form"] = "form";
    HistoryType["info"] = "info";
    HistoryType["isolation"] = "isolation";
    HistoryType["note"] = "note";
    HistoryType["pending"] = "pending";
    HistoryType["quarantine"] = "quarantine";
    HistoryType["success"] = "success";
    HistoryType["warn"] = "warn";
    HistoryType["screener"] = "screener";
    HistoryType["checkin"] = "checkin";
})(HistoryType = exports.HistoryType || (exports.HistoryType = {}));
var NoteType;
(function (NoteType) {
    NoteType["note"] = "note";
    NoteType["incident"] = "incident";
    NoteType["test"] = "test";
})(NoteType = exports.NoteType || (exports.NoteType = {}));
var UserRole;
(function (UserRole) {
    UserRole["VISITOR"] = "visitor";
    UserRole["STAFF"] = "staff";
    UserRole["USER"] = "user";
    UserRole["OFFICE"] = "office";
    UserRole["NURSE"] = "nurse";
    UserRole["PRINCIPAL"] = "principal";
    UserRole["DISTRICT"] = "district";
    UserRole["ADMINISTRATOR"] = "administrator";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
